export var MobileScrollActionTypes;
(function (MobileScrollActionTypes) {
    MobileScrollActionTypes["SET_KEYBOARD_HEIGHT"] = "SET_KEYBOARD_HEIGHT";
    MobileScrollActionTypes["SET_HEIGHT_DIFF"] = "SET_HEIGHT_DIFF";
    MobileScrollActionTypes["SET_WINDOW_HEIGHT"] = "SET_WINDOW_HEIGHT";
})(MobileScrollActionTypes || (MobileScrollActionTypes = {}));
//# sourceMappingURL=actions.js.map